import React, { Component } from 'react';
import _ from 'lodash';
import {
    withStyles,
    Theme,
    createStyles,
    WithStyles,
    Grid,
    Typography,
    Table,
    TableBody,
    TableRow,
    TableCell,
    Avatar,
    Card,
    CardContent
} from '@material-ui/core';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { UserBody } from '../types/UsersBody';
import { MyPATDialog, MyPATIconButton } from '../../common';
import { CloseOutlined as CloseIcon, } from '@material-ui/icons';
import RemoveUserRoleDialog from './RemoveUserRoleDialog';
import { usersList } from '../actions/usersActions';
import AssignRoleDialog from './AssignRoleDialog';
import AddUserDialogOpen from './AddUserDialog';
import ACL from '../../acl/components/ACL';


const styles = (theme: Theme) => createStyles({
    cardContentRoot: {
        position: 'relative',
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        '&:last-child': {
            paddingBottom: theme.spacing.unit * 2,
        },
    },

    profileAvatar: {
        height: theme.spacing.unit * 25,
        width: theme.spacing.unit * 25,
    },
    roleName: {
        textTransform: 'capitalize',
        marginRight: theme.spacing.unit / 2,
        '&:after': {
            content: '","',
        },
        '&:last-child': {
            marginRight: 0,
            '&:after': {
                display: 'none',
            },
        }
    },
    profileTable: {
        width: 'auto',
        '& tbody': {
            '& tr': {
                height: 'auto',
                '& td': {
                    fontSize: theme.typography.body1.fontSize,
                    border: 0,
                    padding: 0,
                    paddingTop: theme.spacing.unit / 2,
                    paddingBottom: theme.spacing.unit / 2,
                    color: theme.palette.text.secondary,
                    '&:first-child': {
                        fontWeight: theme.typography.fontWeightMedium,
                        paddingRight: theme.spacing.unit,
                        color: theme.palette.text.primary,
                    }
                }
            }
        }
    },
    ulDefault: {
        padding: 0,
        margin: 0,
        marginBottom: theme.spacing.unit,
    },
    listItem: {
        display: 'inline-block',
        padding: theme.spacing.unit,
        paddingTop: 0,
        paddingBottom: 0,
        '&:first-child': {
            paddingLeft: 0,
        },
    },
    linkItem: {
        ...theme.typography.body1,
        textDecoration: 'none',
        color: theme.palette.primary.main,
    },
    editDiv: {
        paddingBottom: 0,
    },
    dialogCloseContainer: {
        textAlign: 'right',
    },
});

interface UserProfileCardProps extends WithStyles<typeof styles> {
    userProfile: UserBody,
    users: UserBody[],
    dialogOpen: boolean,
    onClose: () => void,
    usersList: () => void,
    handleAssignDialogue: (isOpen: boolean, e: any) => void,
}

interface UserProfileCardState {
    deleteRoleDialogOpen: boolean,
    userRoles: any,
    assignRoleDialogOpen: boolean,
    selectedUserId: string,
    addUserDialogOpen: boolean,
    userDetails: any,
}


class UserProfileCard extends Component<UserProfileCardProps, UserProfileCardState>{
    constructor(props: UserProfileCardProps) {
        super(props);
        this.state = {
            userDetails: {},
            deleteRoleDialogOpen: false,
            userRoles: [],
            assignRoleDialogOpen: false,
            selectedUserId: '',
            addUserDialogOpen: false
        }
    }
    componentDidMount() {
        this.initilizeData();
    }

    componentWillReceiveProps() {
        setTimeout(this.initilizeData.bind(this), 600);
    }

    initilizeData() {
        const { userProfile, users } = this.props;
        let { userRoles } = this.state
        let userDetails: any = {};
        //Find UserData
        if (!_.isEmpty(userProfile._id)) {
            userDetails = _.find(users, ['_id', userProfile._id]);
            userRoles = [];
            //extract roles
            _.map(userDetails.roles, (role, i) => {
                userRoles.push({ _id: role.roleId._id, name: role.roleId.role, miniLibrary: role.miniLibrary.name, miniLibraryId: role.miniLibrary._id })
            });

            this.setState({ userRoles, userDetails });
        }
    }

    handleRoleDialogue = (isOpen: boolean) => this.setState({ deleteRoleDialogOpen: isOpen });


    handleEditDialogue = (isOpen: boolean) => this.setState({ addUserDialogOpen: isOpen })

    doneUserEdit = () => {
        this.props.usersList();
        this.setState({ addUserDialogOpen: false });
        this.props.onClose();
    }

    render() {
        const { classes, userProfile, onClose, dialogOpen } = this.props;
        const { deleteRoleDialogOpen, userRoles, userDetails, assignRoleDialogOpen, selectedUserId, addUserDialogOpen } = this.state;
        const otherDialogProps = {
            fullWidth: true,
            maxWidth: 'md',
            scroll: 'body',
        };

        return (
            <>

                <MyPATDialog
                    dialogHeading="User Profile"
                    otherDialogProps={otherDialogProps}
                    dialogOpen={dialogOpen}
                    onDialogClose={onClose}
                >
                    <Card>
                        <CardContent className={classes.cardContentRoot}>
                            <Grid container alignItems="center" spacing={16}>
                                <Grid container item xs={12} direction="row" justify="flex-end" className={classes.editDiv}>
                                    <Grid item xs="auto">
                                        <ul className={classes.ulDefault}>
                                            {
    
                                                  <>
                                                        {
                                                            userRoles && userRoles.length > 0 &&
                                                            <li className={classes.listItem} >
                                                                <a
                                                                    href="javascript:void(0)"
                                                                    onClick={this.handleRoleDialogue.bind(this, true)}
                                                                    className={classes.linkItem}
                                                                >
                                                                    Remove Role
                                                            </a>
                                                            </li>
                                                        }
                                                        <li className={classes.listItem} >
                                                            <a
                                                                href="javascript:void(0)"

                                                                onClick={(e) => this.props.handleAssignDialogue(true, e)}
                                                                className={classes.linkItem}
                                                            >
                                                                Assign Role
                                                        </a>
                                                        </li>

                                                        <li className={classes.listItem} >
                                                            <a
                                                                href="javascript:void(0)"
                                                                onClick={this.handleEditDialogue.bind(this, true)}
                                                                className={classes.linkItem}
                                                            >
                                                                Edit
                                                        </a>
                                                        </li>

                                                    </>
                                            }
                                        </ul>
                                    </Grid>
                                </Grid>

                                <Grid item xs="auto">
                                    <Avatar className={classes.profileAvatar} alt={`Profile ${userDetails.fullName}`} src={_.isEmpty(userDetails.profileImage) ? "/assets/img/profile-default.png" : userDetails.profileImage} />

                                </Grid>
                                <Grid item xs>
                                    <Typography variant="h5">
                                        <strong>{_.get(userDetails, 'fullName', '')}</strong>
                                    </Typography>
                                    <Table className={classes.profileTable}>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell>
                                                    User Credential:
                                        </TableCell>
                                                <TableCell>
                                                    {(_.isUndefined(userDetails.userName) || _.isEmpty(userDetails.userName))
                                                        ? _.get(userDetails, 'email', '')
                                                        : _.get(userDetails, 'userName', '')
                                                    }
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>
                                                    User Group:
                                        </TableCell>
                                                <TableCell>
                                                    {
                                                        _.map(userDetails.groupsId, (group, i) =>
                                                            <span key={`group-${i}`} className={classes.roleName}>
                                                                {
                                                                    _.get(group, 'name', '')
                                                                }
                                                            </span>)
                                                    }
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>
                                                    Reviewer:
                                        </TableCell>
                                                <TableCell>
                                                    {
                                                        _.map(userDetails.roles, (b) => (
                                                            !_.isUndefined(b.reviewer) && _.map(b.reviewer, (c, i) => (
                                                                <span key={`reviewer-userProfile-${i}`} className={classes.roleName}>
                                                                    {
                                                                        !_.isUndefined(c) && _.get(c, 'fullName', '')
                                                                    }
                                                                </span>
                                                            ))
                                                        ))
                                                    }
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>
                                                    Role:
                                        </TableCell>
                                                <TableCell>
                                                    {
                                                        _.map(userRoles, (roles, i) =>
                                                            <span key={`role-${i}`} className={classes.roleName}>
                                                                {
                                                                    roles.name
                                                                }
                                                            </span>)
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </MyPATDialog>

                <RemoveUserRoleDialog
                    userDetails={userDetails}
                    userRoles={userRoles}
                    dialogOpen={deleteRoleDialogOpen}
                    onClose={this.handleRoleDialogue.bind(this, false)}
                />


                <AddUserDialogOpen
                    dialogOpen={addUserDialogOpen}
                    userProfile={userDetails}
                    isDone={this.doneUserEdit.bind(this, false)}
                    dialogCloseHandler={this.handleEditDialogue.bind(this, false)}
                />
            </>
        );
    }

}
const mapStateToProps = (state: any) => ({
    users: _.get(state, 'userManagement.users.list', []),
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    usersList
}, dispatch);

//@ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(UserProfileCard));
